interface CopyPageUrlProps {
    el: HTMLElement;
}

const CopyPageUrl = ({ el }: CopyPageUrlProps): void => {
    const pageUrl = document.location.href;

    el.addEventListener('click', async() => {
        try {
            await navigator.clipboard.writeText(pageUrl);
            // const copyLinkText = el.nextElementSibling;
            // copyLinkText?.classList.add('visible');
            // setTimeout(() => {
            //     copyLinkText?.classList.remove('visible');
            // }, 2000);
        } catch (e) {
            // Do nothing
            console.error(e);
        }
    });
};

export default CopyPageUrl;
